module.exports = __webpack_public_path__ + "img/Flag_of_San_Marino.48eb2004.svg";